import * as actionTypes from "../actions/actionTypes";

const initialState = {
    ekey: null,
    data: null,
    loading: false,
    error: false,
    errorMessage: null,
    errorCode: null,
};

const loadListingDashboardStart = (state, action) => {
    return {
        ...state,
        loading: true,
        error: false,
        ekey: action.ekey,
    };
};

const loadListingDashboardSuccess = (state, action) => {
    return {
        ...state,
        loading: false,
        data: action.data,
    };
};

const loadListingDashboardFail = (state, action) => {
    return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.errorMessage,
        errorCode: action.errorCode,
    };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_LISTING_DASHBOARD_START:
            return loadListingDashboardStart(state, action);
        case actionTypes.LOAD_LISTING_DASHBOARD_SUCCESS:
            return loadListingDashboardSuccess(state, action);
        case actionTypes.LOAD_LISTING_DASHBOARD_FAIL:
            return loadListingDashboardFail(state, action);
        default:
            return state;
    }
};

export default reducer;